import { DatePicker, Switch } from "antd";
import { Field, Formik } from "formik";
import moment from "moment";
import { types } from "../../../../store/action_types";
import { useDispatch, useSelector } from "react-redux";
import { Constants } from "../../../../Constants";
import CustomTextArea from "../../../../SharedComponents/CustomTextArea";
import { CalanderIcon } from "../../../../SharedComponents/icons/icons";
import { useEffect, useRef } from "react";

const AddVotes = ({ handleCloseAddVotesModal }) => {
  const formikRef = useRef();
  var minimumDate = new Date();
  const dispatch = useDispatch();
  const { createVotesloading, createVotesModalOpen } = useSelector((state) => ({
    createVotesloading: state.VotesReducer.createVotesloading,
    createVotesModalOpen: state.VotesReducer.createVotesModalOpen,
  }));
  useEffect(() => {
    if (!createVotesModalOpen) {
      formikRef.current.resetForm();
    }
  }, [createVotesModalOpen]);

  return (
    <>
      <div>
        <Formik
          innerRef={formikRef}
          initialValues={{
            votesname: "",
            startdate: "",
            enddate: "",
            firstOption: "",
            secondOption: "",
            thirdOption: "",
            fourthOption: "",
            multiselectStatus: false,
          }}
          onSubmit={(values) => {
            let newStartDate = new Date(values?.startdate);
            let startdateString = moment(newStartDate).toISOString();
            let newendDate = new Date(values?.enddate);
            let enddateString = moment(newendDate).toISOString();
            let data = {
              createVotesData: {
                question: values.votesname,

                startTime: startdateString,
                endTime: enddateString,
                multipleAllowed: JSON.stringify(values?.multiselectStatus),

                choices: [
                  values?.firstOption,
                  values?.secondOption,
                  values?.thirdOption,
                  values?.fourthOption,
                ],
              },
            };

            dispatch({
              type: types.VotesCreationRequest,
              payload: data,
            });
          }}
          validationSchema={Constants.AddVotesSchema}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            values,
          }) => (
            <div className="add-votes-modal-wrapper mt40">
              <div className=" ">
                <div className=" mb-3 ">
                  <Field name="votesname">
                    {({ meta }) => (
                      <CustomTextArea
                        label={"Title"}
                        required={true}
                        customStyle={false}
                        rows={"2"}
                        maxLength={200}
                        name={"votesname"}
                        error={meta.touched ? meta.error : null}
                        onChange={handleChange("votesname")}
                        placeHolderText={"Enter votes name"}
                        value={values.votesname}
                        onBlur={handleBlur("votesname")}
                      />
                    )}
                  </Field>
                </div>
                <div className="col-12 col-sm-12 col-md-12 mb-3 ">
                  <div>
                    <Field name="firstOption">
                      {({ meta }) => (
                        <CustomTextArea
                          label={"Options"}
                          onChange={handleChange("firstOption")}
                          required={true}
                          customStyle={true}
                          rows={"2"}
                          name={"firstOption"}
                          error={meta.touched ? meta.error : null}
                          placeHolderText={"Enter option1 "}
                          value={values?.firstOption}
                          maxLength={50}
                          onBlur={handleBlur("firstOption")}
                        />
                      )}
                    </Field>
                    <div className=" mt10">
                      <Field name="secondOption">
                        {({ meta }) => (
                          <CustomTextArea
                            label={""}
                            customStyle={true}
                            onChange={handleChange("secondOption")}
                            rows={"2"}
                            name={"fOption"}
                            error={meta.touched ? meta.error : null}
                            placeHolderText={"Enter option2 "}
                            value={values?.secondOption}
                            maxLength={50}
                            onBlur={handleBlur("secondOption")}
                          />
                        )}
                      </Field>
                    </div>
                    <div className=" mt10">
                      <Field name="thirdOption">
                        {({ meta }) => (
                          <>
                            <CustomTextArea
                              label={""}
                              customStyle={true}
                              onChange={handleChange("thirdOption")}
                              rows={"2"}
                              name={"thirdOption"}
                              error={meta.touched ? meta.error : null}
                              placeHolderText={"Enter option3 "}
                              value={values?.thirdOption}
                              maxLength={50}
                              onBlur={handleBlur("thirdOption")}
                            />
                          </>
                        )}
                      </Field>
                    </div>
                    <div className=" mt10">
                      <Field name="fourthOption">
                        {({ meta }) => (
                          <CustomTextArea
                            label={""}
                            onChange={handleChange("fourthOption")}
                            rows={"2"}
                            customStyle={true}
                            name={"fourthOption"}
                            error={meta.touched ? meta.error : null}
                            placeHolderText={"Enter option4 "}
                            value={values?.fourthOption}
                            maxLength={50}
                            onBlur={handleBlur("fourthOption")}
                          />
                        )}
                      </Field>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className=" mb-3 ">
                  <label className="d-flex">Start Date *</label>
                  <Field name="startdate">
                    {({ meta }) => (
                      <>
                        <DatePicker
                          className="w-100"
                          showTime
                          name="startdate"
                          onChange={(dateString) =>
                            setFieldValue("startdate", dateString)
                          }
                          value={values.startdate}
                          inputReadOnly={true}
                          showNow={false}
                          disabledDate={(current) =>
                            !current || current.isBefore(minimumDate)
                          }
                          allowClear={false}
                          suffixIcon={<CalanderIcon />}
                        />
                        <p className="errorText">
                          {meta?.touched ? meta?.error : null}
                        </p>
                      </>
                    )}
                  </Field>
                </div>
                <div className=" mb-3 ">
                  <label className="d-flex">End Date *</label>
                  <Field name="enddate">
                    {({ meta }) => (
                      <>
                        <DatePicker
                          className="w-100"
                          inputReadOnly={true}
                          showNow={false}
                          showTime
                          name="enddate"
                          onChange={(dateString) =>
                            setFieldValue("enddate", dateString)
                          }
                          value={values.enddate}
                          disabledDate={(current) =>
                            !current || current.isBefore(minimumDate)
                          }
                          allowClear={false}
                          suffixIcon={<CalanderIcon />}
                        />
                        <p className="errorText">
                          {meta?.touched ? meta?.error : null}
                        </p>
                      </>
                    )}
                  </Field>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <label className="d-flex">Multi-select</label>
                  </div>
                  <div>
                    <Field name="multiselectStatus">
                      {({ meta }) => (
                        <Switch
                          defaultChecked={
                            values.multiselectStatus === "true" ? true : false
                          }
                          onChange={(val) =>
                            setFieldValue("multiselectStatus", val)
                          }
                        />
                      )}
                    </Field>
                  </div>
                </div>
              </div>

              <div className="d-flex ">
                <div>
                  {createVotesloading ? (
                    <button
                      type="submit"
                      className="addbtn border p1040 bgprimary savecancelbtnhightwidth cursor-nodrop"
                    >
                      <div className="whitespinner">
                        <div className="bounce1"></div>
                        <div className="bounce2"></div>
                        <div className="bounce3"></div>
                      </div>
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="addbtn border p1040 bgprimary savecancelbtnhightwidth"
                      onClick={() => handleSubmit()}
                    >
                      <>Publish</>
                    </button>
                  )}
                </div>
                <div className="ml9">
                  <button
                    type="submit"
                    className="cancelbtn border p1040 savecancelbtnhightwidth"
                    onClick={() => handleCloseAddVotesModal()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </Formik>
      </div>
    </>
  );
};
export default AddVotes;
